import { isServer } from '..';
export function isAndroid() {
  /* istanbul ignore next */
  return isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
}
export function isIOS() {
  /* istanbul ignore next */
  return isServer ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.25@vant/es/utils/validate/system.js
// module id = 169
// module chunks = 38